import React, { useState } from "react";
import SignIn from "../Login/SignIn";
import ForgotPassword from "../Login/ForgotPassword";
import OtpVerification from "../Login/OtpVerification";
import ResetPassword from "../Login/ResetPassword";
import { useDispatch, useSelector } from "react-redux";
import { closeSignInModal } from "../../store";

const AuthModalManager = () => {
  const [step, setStep] = useState("signIn"); // 'signIn', 'forgotPassword', 'otp', 'resetPassword'
  const [email, setEmail] = useState(""); // For passing email between steps
  const [otp, setOtp] = useState(""); // For passing OTP code between steps

  const { isSignInModalOpen } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // handle sign-in model
  const handleSignInModel = () => {
    dispatch(closeSignInModal());
  };

  // Handler to move between steps
  const goToStep = (nextStep, data) => {
    setStep(nextStep);
    if (data?.email) setEmail(data.email);
    if (data?.otp) setOtp(data.otp);
  };

  // Render the correct content
  let content;
  if (step === "signIn") {
    content = (
      <SignIn
        isOpen={isSignInModalOpen}
        onClose={handleSignInModel}
        onForgotPassword={() => goToStep("forgotPassword")}
      />
    );
  } else if (step === "forgotPassword") {
    content = (
      <ForgotPassword
        isOpen={isSignInModalOpen}
        onClose={handleSignInModel}
        onOtpSent={(email) => goToStep("otp", { email })}
        onBack={() => goToStep("signIn")}
      />
    );
  } else if (step === "otp") {
    content = (
      <OtpVerification
        isOpen={isSignInModalOpen}
        onClose={handleSignInModel}
        email={email}
        onVerified={(otp) => goToStep("resetPassword", { otp })}
        onBack={() => goToStep("forgotPassword")}
      />
    );
  } else if (step === "resetPassword") {
    content = (
      <ResetPassword
        isOpen={isSignInModalOpen}
        onClose={handleSignInModel}
        onSuccess={() => goToStep("signIn")}
        onBack={() => goToStep("otp", { email, otp })}
        email={email}
        otpCode={otp}
      />
    );
  }

  return <>{content}</>;
};

export default AuthModalManager;
